'use strict';

import { List } from './list.js';

export class ListMyadsdetails extends List {
	constructor(component_key) {
		super(component_key);
		this.$body = jQuery('body');
	}
	add_events() {
		jQuery('body').on('click', `.js-${this.id}_action`, this.action_click_handler.bind(this));
	}
	
	action_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		this.$root = $element.closest(`.js-${this.id}`);
		this.$action = this.$root.find(`.js-${this.id}_action`);
		yalwa.basics.bem_modifier(this.$root, 'active', 'toggle');
	}
}
